import { TsDOM as q} from '@/scripts/core/TsDOM'
import { BuildSetDrawer } from '@/scripts/product/build-set-drawer';
import { BuildSetToggle } from '@/scripts/product/build-set-toggle';
q.safeDefineElement(BuildSetDrawer)
q.safeDefineElement(BuildSetToggle)